/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Description_LabelInputs */



/**
* | output |
* | --- |
* | "Project Description" |
*
* @param {Project_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_description_label = /** @type {((inputs?: Project_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição do projeto")
	return /** @type {LocalizedString} */ ("Project Description")
});